module.exports = __webpack_public_path__ + "static/media/LB.b1167bc3.svg";